<template>
  <div id="kt_footer" class="footer bg-white py-4 d-flex flex-lg-column">
    <!--begin::Container-->
    <v-row wrap>
      <v-col align="center" cols="12" md="4">
        <div class="text-dark order-2 order-md-1">
          <span class="text-muted font-weight-bold mr-2"
            >{{ CurrentYear }}©</span
          >
          <a
            href="https://jciindia.in"
            target="_blank"
            class="text-dark-75 text-hover-primary"
            >JCI India</a
          >
        </div>
      </v-col>
      <v-col align="center" cols="12" md="4">
        <span class="text-muted font-weight-bold mr-2">Powered by </span>
        <a
          href="http://vaagai.org.in"
          target="_blank"
          class="text-dark-75 text-hover-primary"
          >Vaagai Tecknowledge</a
        >
      </v-col>
      <v-col align="center" cols="12" md="4">
        App version {{ AppVersion }}
      </v-col>
      <v-col align="center" cols="12" md="12">
        {{ VersionInfo }}
      </v-col>
    </v-row>

    <!-- Update Required Dialog -->
    <v-dialog v-model="showUpdateDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          Update Available
        </v-card-title>
        <v-card-text>
          {{ UpdateMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" dark elevation="2" @click="refreshPage">
            Update Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { version } from "/package.json";
import common from "@/view/Common.vue";

export default {
  name: "KTFooter",
  mixins: [common],
  data() {
    return {
      AppVersion: version,
      VersionInfo: "",
      UpdateMessage: "",
      PageData: {},
      CurrentYear: new Date().getFullYear(),
      showUpdateDialog: false,
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
  },
  methods: {
    refreshPage() {
      window.location.reload();
    },
  },
  watch: {
    PageData() {
      console.log("PageData changed");
      var tr = this.PageData;
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.VersionInfo = tr.VersionInfo;
        this.UpdateMessage = tr.UpdateMessage;
        // Check if update is required
        if (tr.UpdateRequired === true) {
          this.showUpdateDialog = true;
          // this.refreshPage();
        }
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    var url2 = "api/pages/version-info";
    var condition2 = {
      UserInterface: 1,
      AppVersion: this.AppVersion,
    };
    this.getPageDetails("PageData", "", url2, condition2);
  },
};
</script>
